import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../../language/keys';

type NewTalentDialogActionsProps = {
    disabled: boolean,
    onCancelClick: () => void,
    onContinueClick: () => void,
  }

export default function NewTalentDialogActions({
  disabled,
  onCancelClick,
  onContinueClick,
}:NewTalentDialogActionsProps):JSX.Element {
  const { t: translate } = useTranslation();

  return (
    <DialogActions>
      <Button onClick={ onCancelClick }>{translate(STRING_KEYS.CANCEL)}</Button>
      <Button variant="contained"
        onClick={ onContinueClick }
        disabled={ disabled }
      >{translate(STRING_KEYS.CONTINUE)}
      </Button>
    </DialogActions>
  );
}
